/**
 * CSV document icon for export-to-CSV actions; supports a color prop for enabled/disabled states.
 */
import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconExportCsv = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="17" height="23" viewBox="0 0 17 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.3647 0H2.45078C1.10951 0 0 1.13741 0 2.51952V19.8896C0 21.2717 1.10951 22.4091 2.45078 22.4091H14.5495C15.8908 22.4091 17 21.2717 17 19.8896V6.09138L11.3647 0Z"
                fill={color}
            />
            <path
                d="M11.5908 0L16.9999 6.18182H13.3991C12.3993 6.18182 11.5908 5.30291 11.5908 4.21582V0Z"
                fill={color}
            />
            <text
                x="8.5"
                y="17.5"
                textAnchor="middle"
                fill="white"
                fontSize="4.5"
                fontWeight="700"
                fontFamily="sans-serif"
            >
                CSV
            </text>
        </svg>
    </div>
);

export default IconExportCsv;
